/**
 * The only money arithmetic on the tablet (T07-33, docs/dev/pos-offline-contract.md §1): while
 * offline the register shows the **sum** of the 税込 prices of its copy (Σ qty × price) and the
 * change of a cash payment — no tax (tax-service computes it when the sale is uploaded, with the
 * time the cash was taken). Online, every amount is the server's (`features/sale` has none).
 */

export interface PricedLine {
  qty: number;
  unitPrice: number;
}

export function offlineTotal(lines: readonly PricedLine[]): number {
  return lines.reduce((sum, line) => sum + line.qty * line.unitPrice, 0);
}

export function offlineChange(total: number, tendered: number): number {
  return tendered - total;
}

/** 「ちょうど」 + the next ¥1,000 / ¥5,000 / ¥10,000 above the total (cash quick buttons). */
export function cashSuggestions(total: number): number[] {
  const out = new Set<number>([total]);
  for (const step of [1_000, 5_000, 10_000]) {
    out.add(Math.ceil(total / step) * step);
  }
  return [...out]
    .filter((v) => v >= total && v > 0)
    .sort((a, b) => a - b)
    .slice(0, 4);
}
